const AttendeeRole = {
  Moderator: 'MODERATOR',
  Participant: 'PARTICIPANT',
  Spectator: 'SPECTATOR',
}

export default AttendeeRole
